import Project from "../project";

/**
 * Specific shared services for Multibed
 * Functions should be kept clean and pure, avoiding side effects or data mutation
 * @type {{validateOutletOverIsolator: (function(*, *, *): boolean), testSelectedChambersBeforeRemoval: (function(*, *): boolean), validateInternalOutletOnPerimeterRow(*, *, *): boolean, validateIsolatorOverOutlet: (function(*, *, *): boolean), validateSelectedChamberIsActive: (function(*, *): boolean), getActualRows: (function(*, *=, *=, *=, *=, *, *): *), handleManifoldBuildRestrictions: (function(*=, *=): null), removeSelectedChambers: (function(*, *, *): boolean), getChamberCapAccessory: (function(*=, *=, *): ({id: null}|*)), validateInnerFreeSpace: (function(*, *, *, *=, *): boolean), ignoreAccessoryAttachment: (function(*=, *): boolean)}}
 */
const ProjectService = {
    /**
     * generates a full new instance of the project
     * @param project - Requires "this.props.project"
     */
    getNewProjectInstance: ( project ) => {

        if (project && project.RowKey) {
            project["id"] = project.RowKey;
        }

        return new Project(
            project.id,
            project.projectName,
            project.engineer,
            project.city,
            project.state,
            project.country,
            project.region,
            project.language,
            project.createdDate,
            project.statusDate,
            project.editedDate,
            project.processingStatus,
            project.bomFileUrl,
            project.active,
            project.workItemId,
            project.inputFileURL,
            project.outputFileURL,
            project.projectType,
            project.outputFileURLPipe,
            project.bomFileUrlPipe,
            project.isMultiBedProject,
        );
    },

};

export default ProjectService;



// WEBPACK FOOTER //
// ./src/lib/services/project-service.js